import React, { useState, useEffect } from "react";
import Loader from "../../../Common/Loader/loader";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import * as XLSX from "xlsx";
import ExcelJS from "exceljs";
import { Tab, Tabs, TabPanel, TabList } from "react-tabs";
import { AllOwnerTypeDetails } from "../../../Apis/ownerTypeApi";
import {
  getAllCircleZoneWiseReport,
  getAllCircleWiseReportCircle,
} from "../../../Apis/scvReports/reportedSCVApi.";
import { AllShiftMaster } from "../../../Apis/shiftMasterApi";
import CustomDataTable from "../../../Common/ReportTable/ReportTable";
import { AllVehicleTypeDetails } from "../../../Apis/vehicleApi";
// import { AllSecondaryCollectionTransaction, GetAllClearedCollectionPointTransaction, GetAllSecondaryDeploymentTransaction, GetAllVehicleDetails, GetSecondaryVehicleNotReportedAtDeployment,GetAllClearedHotspotTransaction } from "../../../Apis/TransferStationReport/secondaryCollectionTransactionApi";
import {
  GetAllClearedCollectionPointTransaction,
  GetAllTotalClearedHotspotTransaction,
  GetAllSecondaryDeploymentTransaction,
  GetAllVehicleDetailsByFilters,
  GetSecondaryVehicleNotReportedAtDeployment,
  GetAllClearedHotspotTransaction,
  GetAllClearedHotspotTransactionTotal,
  TotalDeploymentTransaction,
} from "../../../Apis/TransferStationReport/secondaryCollectionTransactionApi";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router";
import {
  AllSecondaryDeploymentReport,
  TotalDeploymentReport,
  AllSecondaryTotalDeploymentReport,
  SecondaryTotalDeploymentReport
} from "../../../Apis/TransferStationReport/secondaryDeploymentTransactionReportApi";
import isGHMC, { formattedDate, getCurrentDateTime1, getCurrentISTDate } from "../../../Common/helper/helpar";
const CircleReport = () => {
  // zone wise reported scvs at circle local storage for filters hold
  const OwnerType = localStorage.getItem("ownerType");
  const VehicleType = localStorage.getItem("vehicleType");
  const date = localStorage.getItem("date");
  const shift = localStorage.getItem("shift");

  const CircleOwnerType = localStorage.getItem("CircleOwnerType");
  const CircleVehicleType = localStorage.getItem("CircleVehicleType");
  const Circledate = localStorage.getItem("Circledate");

  
  const CircleShift = localStorage.getItem("CircleShift");
  const {
    register,
    handleSubmit,
    watch,
    reset,
    setValue,
    formState: { errors },
  } = useForm();
  const navigate = useNavigate();
  const [selectedTab, setSelectedTab] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [ownerType, setOwnerType] = useState([]);
  const [vehicleType, setVehicleType] = useState([]);
  const [shiftType, setShiftType] = useState([]);
  const [circleZonewisereport, setcircleZonewisereport] = useState([]);
  const [circleZonewisereportcircle, setcircleZonewisereportcircle] = useState(
    []
  );
  const [isOptionsLoading, setIsOptionsLoading] = useState(false);
  const [getCircleReport, setgetCircleReport] = useState([]);
  const [sortConfig, setSortConfig] = useState({ column: null, order: null });

  const [formInput, setFormInput] = useState({
    Date: date ? date : getCurrentDateTime(),
    ownerTypeId: OwnerType || "",
    vehicleTypeId:VehicleType || "",
    shiftId: shift ? shift : 1,
  });
  const [formInput1, setFormInput1] = useState({
    Date: Circledate ? Circledate : getCurrentDateTime(),
    ownerTypeId: CircleOwnerType || "",
    vehicleTypeId:CircleVehicleType || "",
    shiftId: CircleShift ? CircleShift : 1,
  });
  const isProd = isGHMC();

  useEffect(() => {
    const savedTab = localStorage.getItem("selectedTab");
    if (savedTab) {
      setSelectedTab(parseInt(savedTab, 10));
    }
  }, []);


  const handleTabSelect = (index) => {
    setSelectedTab(index);
    localStorage.setItem("selectedTab", index);
  };
  const handleSort = (column) => {
    const newSortConfig = {
      column,
      order:
        sortConfig.column === column && sortConfig.order === "asc"
          ? "desc"
          : "asc",
    };
    setSortConfig(newSortConfig);
  };

  const fetchCircleZonewisereport = async () => {
    try {
      setIsLoading(true);
      const res = await getAllCircleZoneWiseReport({
        Date: formInput.Date,
        OwnerTypeId: formInput.ownerTypeId,
        VehicleTypeId: formInput.vehicleTypeId,
        ShiftId: formInput.shiftId,
      });
      setcircleZonewisereport(res.data);
    } catch (error) {
      console.error(
        "Error fetching get circle zone wise reports  by ID:",
        error
      );
    } finally {
      setIsLoading(false);
    }
  };

  const fetchCircleZonewisereportCircle = async (zoneId) => {
    try {
      setIsLoading(true);
      const res = await getAllCircleWiseReportCircle(
        
      );
      setcircleZonewisereportcircle(res.data);
    } catch (error) {
      console.error(
        "Error fetching get circle wise reports circle  by ID:",
        error
      );
    } finally {
      setIsLoading(false);
    }
  };

  const fetchOwnerData = async () => {
    try {
      const data = await AllOwnerTypeDetails();
      setOwnerType(data);
    } catch (error) {
      console.error("Error fetching owner Data by ID:", error);
    }
  };

  
  const fetchVehicleTypeData = async () => {
    try {
      const data = await AllVehicleTypeDetails();
      setVehicleType(data);
    } catch (error) {
      console.error("Error fetching owner Data by ID:", error);
    }
  };
  const fetchShiftData = async () => {
    try {
      const data = await AllShiftMaster();
      setShiftType(data);

      // Set the default shift ID to the ID of the first shift in the response
      if (data.length > 0) {
        setFormInput((prevFormInput) => ({
          ...prevFormInput,
          // shiftId: data[0].shiftId,
        }));
        setFormInput1((prevFormInput1) => ({
          ...prevFormInput1,
          // shiftId: data[0].shiftId,
        }));
        // Trigger the zone-wise report API call with the default shift ID
        fetchCircleZonewisereport();
        searchCircleReport();
      }
    } catch (error) {
      console.error("Error fetching shift data:", error);
    }
  };

  useEffect(() => {
    // Set current date and time on page load
    const currentDate = new Date().toISOString().slice(0, 16);
    setValue("Date", currentDate);
  }, []);
  useEffect(() => {
    if (selectedTab === 0) {
      fetchCircleZonewisereport({ Date: new Date().toISOString() });
    } else {
      fetchCircleZonewisereportCircle({ Date: new Date().toISOString() });
    }
  }, [selectedTab]);

  useEffect(() => {
    fetchOwnerData();
    fetchVehicleTypeData()
    fetchShiftData();
    fetchCircleZonewisereport();
    fetchCircleZonewisereportCircle();
    // Simulate loading data
    setIsLoading(true);

    // Assuming you have an asynchronous data fetching process
    fetchData()
      .then(() => setIsLoading(false)) // Once data fetching is done, set isLoading to false
      .catch((error) => {
        setIsLoading(false); // Set isLoading to false in case of error
        console.error("Error fetching data:", error);
        // Handle error (e.g., show error message)
      });
  }, []); // Empty dependency array means this effect runs only once on mount

  // Function to simulate asynchronous data fetching
  const fetchData = async () => {
    await new Promise((resolve) => setTimeout(resolve, 2000));
  };

  const generatePDF = () => {
    const table = document.getElementById("project-reports");
    if (!table) {
      console.error("Target table element not found.");
      return;
    }

    // Create a new jsPDF instance
    const pdf = new jsPDF("p", "pt", "a4");

    // Capture the entire HTML table
    html2canvas(table).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const imgWidth = 500;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      // Add the image of the entire HTML table to the PDF
      pdf.addImage(imgData, "PNG", 40, 40, imgWidth, imgHeight);

      // Save the PDF
      pdf.save("CumulativeReport.pdf");
    });
  };

  const option = { day: "numeric", month: "numeric", year: "numeric" };
  const generationTimes = ` ${new Date()
    .toLocaleString("en-GB", option)
    .replace(/\//g, "/")}`;

    const getShiftName = (shiftId) => {
      const shift = shiftType.find((s) => s.shiftId === parseInt(shiftId));
      return shift ? shift.shiftName : "N/A";
    };
  

  const downloadAsExcel = async () => {
    // Create a new workbook and add a worksheet
    const currentDate = new Date();
    const formattedDates = `${currentDate.getDate()}-${currentDate.getMonth() + 1}-${currentDate.getFullYear()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const downloadDateTime = `Reported on: ${formattedDates}, ${formattedTime}`;
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Zones");

    // Define styles
    const boldFont = { bold: true };

    // Add the downloadDateTime
    worksheet.addRow(["", "", downloadDateTime, ""]);
    worksheet.mergeCells(1, 2, 1, 7);
    worksheet.getCell(1, 2).value = downloadDateTime;
    worksheet.getCell(1, 2).font = boldFont;
    worksheet.getCell(1, 2).alignment = { horizontal: "center" };

    // Apply styles to the merged cells
    for (let col = 2; col <= 7; col++) {
      worksheet.getCell(1, col).font = boldFont;
      worksheet.getCell(1, col).alignment = { horizontal: "center" };
    }

    // Add the heading
    worksheet.addRow(["", "", `Zone Wise Reported SCVs at Circle ${formInput.Date ? formattedDate(formInput.Date) : getCurrentISTDate()}`, ""]);
    worksheet.mergeCells(2, 2, 2, 7);
    worksheet.getCell(2, 2).value = `Zone Wise Reported SCVs at Circle ${formInput.Date ? formattedDate(formInput.Date) : getCurrentISTDate()} - ${getShiftName(formInput.shiftId)} (at ${getCurrentDateTime1()})`;
    worksheet.getCell(2, 2).font = boldFont;
    worksheet.getCell(2, 2).alignment = { horizontal: "center" };

    // Apply styles to the merged cells
    for (let col = 2; col <= 7; col++) {
      worksheet.getCell(2, col).font = boldFont;
      worksheet.getCell(2, col).alignment = { horizontal: "center" };
    }

    // Add empty row for spacing
    worksheet.addRow([""]);

    // Add table header row
    const tableHeaderRow = worksheet.addRow([
      "S.No",
      "Zone",
      "No of Vehicles Alloted",
      "No of Vehicles Reported",
      "No of Vehicles Not Reported",
      "No of GVP Cleared",
      "No of Helpers",
    ]);

    tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      cell.font = boldFont;
      cell.alignment = { horizontal: "left" };
      if (colNumber >= 1 && colNumber <= 7) {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "F6B1B1" }, // Red background color
        };
      }
    });

    // Initialize totals
    let totalAllotedVehicles = 0;
    let totalReportedVehicles = 0;
    let totalNotReportedVehicles = 0;
    let totalClearedCollectionPoints = 0;
    let totalHelpers = 0;

    // Add data rows and accumulate totals
    circleZonewisereport.forEach((item, index) => {
      worksheet
        .addRow([
          index + 1,
          item.zoneName,
          item.allotedVehicleRCV,
          item.reportedVehicleRCV,
          item.notReportedRCV,
          item.clearedCollectionPoints,
          item.numberOfHelpers,
        ])
        .eachCell({ includeEmpty: true }, (cell) => {
          cell.alignment = { horizontal: "left" };
        });

      // Accumulate totals
      totalAllotedVehicles += item.allotedVehicleRCV || 0;
      totalReportedVehicles += item.reportedVehicleRCV || 0;
      totalNotReportedVehicles += item.notReportedRCV || 0;
      totalClearedCollectionPoints += item.clearedCollectionPoints || 0;
      totalHelpers += item.numberOfHelpers || 0;
    });

    // Add total row
    const totalRow = worksheet.addRow([
      "",
      'Total',
      totalAllotedVehicles,
      totalReportedVehicles,
      totalNotReportedVehicles,
      totalClearedCollectionPoints,
      totalHelpers,
    ]);

    totalRow.eachCell({ includeEmpty: true }, (cell) => {
      cell.font = boldFont; // Make total row bold
      cell.alignment = { horizontal: "left" }; // Center align the content
    });

    // Set column widths dynamically based on content
    worksheet.columns = [
      { width: 5 },
      { width: 20 },
      { width: 24 },
      { width: 24 },
      { width: 26 },
      { width: 20 },
      { width: 20 },
    ];

    // Save the workbook to a file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "ZoneWiseSCVsReport.xlsx";
    a.click();
    URL.revokeObjectURL(url);
  };



  const options = { day: "numeric", month: "numeric", year: "numeric" };
  const generationTime = ` ${new Date()
    .toLocaleString("en-GB", options)
    .replace(/\//g, "/")}`;


  const downloadAsExcelforCircleWiseReport = async () => {
    // Create a new workbook and add a worksheet
    const currentDate = new Date();
    const formattedDates = `${currentDate.getDate()}-${currentDate.getMonth() + 1}-${currentDate.getFullYear()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const cumulativeHeadingReport = `Circle Wise Reported SCVs at Circle ${formInput.Date ? formattedDate(formInput.Date) : getCurrentISTDate()} -  ${getShiftName(formInput1.shiftId)} (at ${getCurrentDateTime1()})`;
    const downloadDateTime = `Reported on: ${formattedDates}, ${formattedTime}`;
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Circles");

    // Define styles
    const boldFont = { bold: true };

    // Add the downloadDateTime row
    worksheet.addRow(["", "", downloadDateTime, ""]);
    worksheet.mergeCells(1, 2, 1, 7);
    worksheet.getCell(1, 2).value = downloadDateTime;
    worksheet.getCell(1, 2).font = boldFont;
    worksheet.getCell(1, 2).alignment = { horizontal: "center" };

    // Apply styles to the merged cells
    for (let col = 2; col <= 7; col++) {
      worksheet.getCell(1, col).font = boldFont;
      worksheet.getCell(1, col).alignment = { horizontal: "center" };
    }

    // Add "Circle Wise SCVs Reports" title
    worksheet.addRow(["", "", cumulativeHeadingReport, ""]);
    worksheet.mergeCells(2, 2, 2, 7);
    worksheet.getCell(2, 2).value = cumulativeHeadingReport;
    worksheet.getCell(2, 2).font = boldFont;
    worksheet.getCell(2, 2).alignment = { horizontal: "center" };

    // Apply styles to the merged cells for the title row
    for (let col = 2; col <= 7; col++) {
      worksheet.getCell(2, col).font = boldFont;
      worksheet.getCell(2, col).alignment = { horizontal: "center" };
    }

    // Add empty row for spacing (remove this line to eliminate the gap)
    // worksheet.addRow([""]);

    // Add table header row with bold font
    const tableHeaderRow = worksheet.addRow([
      "S.No",
      "Circle",
      "No of Vehicles Alloted",
      "No of Vehicles Reported",
      "No of Vehicles Not Reported",
      "No of GVP Cleared",
      "No of Helpers",
    ]);

    tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      cell.font = boldFont;
      cell.alignment = { horizontal: "left" };
      if (colNumber >= 1 && colNumber <= 7) {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "F6B1B1" }, // Red background color
        };
      }
    });

    // Initialize totals
    let totalAlloted = 0;
    let totalReported = 0;
    let totalNotReported = 0;
    let totalGvpCleared = 0;
    let totalHelpers = 0;

    // Add data rows and calculate totals
    getCircleReport.forEach((item, index) => {
      totalAlloted += item.allotedVehicleRCV;
      totalReported += item.reportedVehicelRCV;
      totalNotReported += item.notReportedRCV;
      totalGvpCleared += item.clearedCollectionPoints;
      totalHelpers += item.numberOfHelpers;

      worksheet.addRow([
        index + 1,
        item.circleName?? "N/A",
        item.allotedVehicleRCV?? "N/A",
        item.reportedVehicelRCV?? "N/A",
        item.notReportedRCV?? "N/A",
        item.clearedCollectionPoints?? "N/A",
        item.numberOfHelpers?? "N/A",
      ]).eachCell({ includeEmpty: true }, (cell, colNumber) => {
        if (colNumber >= 1 && colNumber <= 7) {
          cell.alignment = { horizontal: "left" };
        } else {
          cell.alignment = { horizontal: "center" };
        }
      });
    });

    // Add the total row directly after the data rows (no gap)
    const totalRow = worksheet.addRow([
      "",
      "Total",
      totalAlloted,
      totalReported,
      totalNotReported,
      totalGvpCleared,
      totalHelpers,
    ]);

    totalRow.eachCell({ includeEmpty: true }, (cell) => {
      cell.font = boldFont; // Make the total row bold
      cell.alignment = { horizontal: "left" }; // Align left
    });

    // Set column widths dynamically based on content
    worksheet.columns = [
      { width: 5 },
      { width: 20 },
      { width: 24 },
      { width: 24 },
      { width: 26 },
      { width: 20 },
      { width: 20 },
    ];

    // Save the workbook to a file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "CircleWiseSCVsReport.xlsx";
    a.click();
    URL.revokeObjectURL(url);
  };



  const scvZoneReportColumns = [
    {
      name: "S.No",
      selector: (row) => row["sno"],
      width: "7%",
      //  sortable: true,
      format: (row, rowIndex) => rowIndex + 1,
    },
    {
      name: "Zone",
      // width: "11%",
      selector: (row) => row["zoneName"],
      cell: (row) => row.zoneName === "Total" ? (
        <span>
          {row["zoneName"]}
        </span>) :
        (<span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => handleZoneClick(row)}
        >
          {row["zoneName"]}
        </span>
        ),
    },
    {
      name: (
        <>
          No of Vehicles <br />
          Alloted{" "}
        </>
      ),
      // width: "17%",
      selector: (row) => row["allotedVehicleRCV"],
      cell: (row) => (
        <span
        // onClick={() =>{
        //   if(row.zoneName === 'Total'){
        //     handleTotalDeploymentClick()
        //   }else{
        //     handleDeploymentClick(row)
        //   }
        // } }
        // style={{ color: "blue", cursor: "pointer" }}
        // onClick={() => handleCircleClick(row["circleId"], row["zoneId"])}
        >
          {row["allotedVehicleRCV"]}
        </span>
      ),
      //  sortable: true,
    },
    {
      name: (
        <>
          No of Vehicles <br />
          Reported
        </>
      ),
      // width: "19%",
      selector: (row) => row["reportedVehicleRCV"],
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            if (row.zoneName === "Total") {
              handleTotalDeploymentClick();
            } else {
              handleDeploymentClick(row);
            }
          }}
        >
          {row["reportedVehicleRCV"]}
        </span>
      ),
      //   sortable: true,
    },
    {
      name: (
        <>
          No of Vehicles Not <br />
          Reported
        </>
      ),
      // width: '20%',
      selector: (row) => row["notReportedRCV"],
      cell: (row) => (
        <span
        //       onClick={() => {
        //         if(row.zoneName === 'Total'){
        //           handleTotalGvpTransactionClick()
        //         }else{
        // handleGvpTransactionClick(row)
        //         }
        //       }}
        >
          {row["notReportedRCV"]}
        </span>
      ),
      //   sortable: true,
    },
    {
      name: "No.of GVPs Cleared",
      // width: "15%",
      selector: (row) => row["clearedCollectionPoints"],
      cell: (row) => (
        <span
          style={{ color: "blue",  cursor: "pointer" }}
          onClick={() => {
            if (row.zoneName === "Total") {
              handleTotalGvpTransactionClick();
            } else {
              handleGvpTransactionClick(row);
            }
          }}
        >
          {row["clearedCollectionPoints"]}
        </span>
      ),
      //    sortable: true,
    },
    {
      name: "No.of Helpers",
      // width: "12%",
      selector: (row) => row["numberOfHelpers"],
      cell: (row) => (
        <span
        //         onClick={() => {
        //           if(row.zoneName === 'Total'){
        //             handleTotalGvpTransactionClick()
        //           }else{
        // handleGvpTransactionClick(row)
        //           }
        //         }}
        // style={{ color: "blue", cursor: "pointer" }}
        // onClick={() => handleTwoTripClick(row, fromDate, toDate)}
        >
          {row["numberOfHelpers"]}
        </span>
      ),
      //   sortable: true,
    },
    // {
    //   name: "No of Equipment Alloted",
    //   // width:'13%',
    //   selector: (row) => (
    //     <span

    //     // onClick={() => handleThreeTripClick(row, fromDate, toDate)}
    //     >
    //       {row["allotedVehicleLoadingEquipment"]}
    //     </span>
    //   ),
    //   sortable: true,
    // },
    // {
    //   name: "No of Equipment Reported",
    //   width: "13%",
    //   selector: (row) => (
    //     <span
    //       style={{ color: "blue", cursor: "pointer" }}
    //       // onClick={() => handleFourTripClick(row, fromDate, toDate)}
    //     >
    //       {row["reportedVehicleLoadingEquipment"]}
    //     </span>
    //   ),
    //   sortable: true,
    // },
    // {
    //   name: "No of Not Equipment Reported",
    //   // width:'13%',
    //   selector: (row) => (
    //     <span

    //     // onClick={() => handleMoreThanFourTripClick(row, fromDate, toDate)}
    //     >
    //       {row["notReportedLoadingEquipment"]}
    //     </span>
    //   ),
    //   sortable: true,
    // },
  ];

  const scvCircleReportColumns = [
    {
      name: "S.No",
      width: "7%",
      selector: (row) => row["sno"],
      //  sortable: true,
      format: (row, rowIndex) => rowIndex + 1,
    },
    {
      name: "Circle",
      // width: "10%",
      selector: (row) => row["circleName"],

      cell: (row) => (
        <span
        //         onClick={() => {
        //           if(row.zoneName === 'Total'){
        //             handleTotalGvpTransactionClick()
        //           }else{
        // handleGvpTransactionClick(row)
        //           }
        //         }}
        // onClick={() => handleZoneClick(row["zoneId"])}
        >
          {row["circleName"]}
        </span>
      ),
      //      sortable: true,
    },
    {
      name: (
        <>
          No of Vehicles
          <br />
          Alloted
        </>
      ),
      // width: "16%",
      selector: (row) => row["allotedVehicleRCV"],
      cell: (row) => (
        <span
        //         onClick={() => {
        //           if(row.zoneName === 'Total'){
        //             handleTotalGvpTransactionClick()
        //           }else{
        // handleGvpTransactionClick(row)
        //           }
        //         }}
        // style={{ color: "blue", cursor: "pointer" }}
        // onClick={() => handleCircleClick(row["circleId"], row["zoneId"])}
        >
          {row["allotedVehicleRCV"]}
        </span>
      ),
      //     sortable: true,
    },
    {
      name: (
        <>
          No of Vehicles <br />
          Reported
        </>
      ),
      // width: "220px",
      selector: (row) => row["reportedVehicelRCV"],
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            if (row.circleName === "Total") {
              handleTotalDeploymentClick1();
            } else {
              handleDeploymentClick1(row);
            }
          }}
        >
          {row["reportedVehicelRCV"]}
        </span>
      ),
      //    sortable: true,
    },
    {
      name: (
        <>
          No of Vehicles Not <br />
          Reported
        </>
      ),
      // width: "19%",
      selector: (row) => row["notReportedRCV"],
      cell: (row) => (
        <span
        //       onClick={() => {
        //         if(row.zoneName === 'Total'){
        //           handleTotalGvpTransactionClick()
        //         }else{
        // handleGvpTransactionClick(row)
        //         }
        //       }}
        >
          {row["notReportedRCV"]}
        </span>
      ),
      //    sortable: true,
    },
    {
      name: "No.of GVPs Cleared",
      // width: "15%",
      selector: (row) => row["clearedCollectionPoints"],
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            if (row.circleName === "Total") {
              handleTotalGvpTransactionClick1();
            } else {
              handleGvpTransactionClick1(row);
            }
          }}
        >
          {row["clearedCollectionPoints"]}
        </span>
      ),
      //    sortable: true,
    },
    {
      name: "No.of Helpers",
      // width: "14%",
      selector: (row) => row["numberOfHelpers"],
      cell: (row) => (
        <span
        // style={{ color: "blue", width: "200px" }}
        // onClick={() => handleTwoTripClick(row, fromDate, toDate)}
        >
          {row["numberOfHelpers"]}
        </span>
      ),
      //    sortable: true,
    },

  ];

  const handleZoneClick = async (zone) => {
    // console.log(zone, "zone 47");
    localStorage.setItem("zone", zone.zoneId);

    // searchCircleReport(zoneId);
    setIsOptionsLoading(true);
    try {
      const res = await getAllCircleWiseReportCircle({
        Date: formInput.Date,
        OwnerTypeId: formInput.ownerTypeId,
        VehicleTypeId:formInput.vehicleTypeId,
        zoneId: zone.zoneId,
        ShiftId: formInput.shiftId,
      });

      // handleOneTimeClick(zoneId);
      navigate("/view-scvs-circle-report", { state: {data:res.data, formatDate: formInput.Date,shiftName:getShiftName(formInput.shiftId)} });
      // console.log(res.data, "circleDataResponse");
    } catch (error) {
      console.log(error);
    } finally {
      setIsOptionsLoading(false);
    }
  };

  localStorage.setItem("date", formInput.Date);
  localStorage.setItem("ownerTypeId", formInput.ownerTypeId);
  localStorage.setItem("vehicleTypeId", formInput.vehicleTypeId);
  //localStorage.setItem("date",zoneId)
  localStorage.setItem("shiftId", formInput.shiftId);

  const searchCircleReport = async (e) => {
    e?.preventDefault();
    setIsOptionsLoading(true);
    try {
      const res = await getAllCircleWiseReportCircle({
        Date: formInput1.Date,
        OwnerTypeId: formInput1.ownerTypeId,
        VehicleTypeId: formInput1.vehicleTypeId,
        zoneId: "",
        ShiftId: formInput1.shiftId,
      });
      const circleDataResponse = res.data.map((circleData) => ({
        ...circleData,
        circle: circleData.circleName,
      }));
      // setgetCircleReport(res.data)
      setgetCircleReport(circleDataResponse);
      // console.log(circleDataResponse, "circleDataResponse");
    } catch (error) {
      console.log(error);
    } finally {
      setIsOptionsLoading(false);
    }
  };

  const handleDeploymentClick = async (row) => {
    // console.log(row, "47 row");
    setIsOptionsLoading(true);
    try {
      const startTime = "00:00";
      const endTime = "23:59";
      let response;
      // Concatenate start and end times with the date
      const startDate = `${formInput.Date}T${startTime}`;
      const endDate = `${formInput.Date}T${endTime}`;
      if (row.zoneId !== "" && row.circleId === "") {
        response = await AllSecondaryDeploymentReport(
          startDate,
          endDate,
          "",
          row.circleId, // Pass empty string for circleId
          formInput.ownerTypeId,
          formInput.shiftId,
          formInput.vehicleTypeId,
          "",
        );
      }
      if (row.zoneId !== "" && row.circleId !== "") {
        // console.log(row.circleId, "row.circleId 47"); // Add this line to log the circleId
        response = await AllSecondaryDeploymentReport(
          startDate,
          endDate,
          row.zoneId,
          "", // Pass empty string for circleId
          formInput.ownerTypeId,
          formInput.shiftId,
          formInput.vehicleTypeId
        );
      }
      navigate("/view-vehicle-inner-report", { state:{data:response.data,formatDate: formInput.Date,shiftName:getShiftName(formInput.shiftId)}});
    } catch (error) {
      console.log(error);
    } finally {
      setIsOptionsLoading(false);
    }
  };

  const handleTotalDeploymentClick = async () => {
    setIsOptionsLoading(true);
    try {
      const startTime = "00:00";
      const endTime = "23:59";
      const startDate = `${formInput.Date}T${startTime}`;
      const endDate = `${formInput.Date}T${endTime}`;

      // Call a different API for the total of the column
      const response = await AllSecondaryDeploymentReport(
        startDate,
        endDate,
        "",
        "",
        formInput.ownerTypeId,
        formInput.shiftId,
        formInput.vehicleTypeId
      );

      navigate("/view-vehicle-inner-report", { state:{data:response.data,formatDate: formInput.Date,shiftName:getShiftName(formInput.shiftId)}});
    } catch (error) {
      console.log(error);
    } finally {
      setIsOptionsLoading(false);
    }
  };

  const handleDeploymentClick1 = async (row) => {
    setIsOptionsLoading(true);
    try {
      const startTime = "00:00";
      const endTime = "23:59";
      let response;
      // Concatenate start and end times with the date
      const startDate = `${formInput1.Date}T${startTime}`;
      const endDate = `${formInput1.Date}T${endTime}`;
      if (row.zoneId !== "" && row.circleId === "") {
        response = await AllSecondaryDeploymentReport(
          startDate,
          endDate,
          "",
          row.circleId, // Pass empty string for circleId
          formInput1.ownerTypeId,
          formInput1.shiftId,
          formInput1.vehicleTypeId
        );
      }
      if (row.zoneId !== "" && row.circleId !== "") {
        response = await AllSecondaryDeploymentReport(
          startDate,
          endDate,
          "",
          row.circleId, // Pass empty string for circleId
          formInput1.ownerTypeId,
          formInput1.shiftId,
          formInput1.vehicleTypeId
        );
      }

      navigate("/view-vehicle-inner-report", { state:{data:response.data,formatDate: formInput1.Date,shiftName:getShiftName(formInput1.shiftId)} });
    } catch (error) {
      console.log(error);
    } finally {
      setIsOptionsLoading(false);
    }
  };

  const handleTotalDeploymentClick1 = async () => {
    setIsOptionsLoading(true);
    try {
      const startTime = "00:00";
      const endTime = "23:59";
      const startDate = `${formInput1.Date}T${startTime}`;
      const endDate = `${formInput1.Date}T${endTime}`;

      // Call a different API for the total of the column
      const response = await AllSecondaryDeploymentReport(
        startDate,
        endDate,
        "",
        "",
        formInput1.ownerTypeId,
        formInput1.shiftId,
        formInput1.vehicleTypeId
      );

      navigate("/view-vehicle-inner-report", { state:{data:response.data,formatDate: formInput1.Date,shiftName:getShiftName(formInput1.shiftId)} });
    } catch (error) {
      console.log(error);
    } finally {
      setIsOptionsLoading(false);
    }
  };
  const handleGvpTransactionClick = async (row) => {
    setIsOptionsLoading(true);
    try {
      const startTime = "00:00";
      const endTime = "23:59";
      // Concatenate start and end times with the date
      const startDate = `${formInput.Date}T${startTime}`;
      const endDate = `${formInput.Date}T${endTime}`;

      // Call the API only when the "No of GVPs Cleared" field is clicked
      if (row.zoneId !== "" && row.circleId !== "") {
        // Call the API
        const response = await GetAllClearedHotspotTransaction(
          startDate,
          endDate,
          row.zoneId,
          "",
      
          formInput.shiftId,
          formInput.ownerTypeId,
          formInput.vehicleTypeId
        );
        // Handle the response here (e.g., navigate to a new page with the data)
        navigate("/view-Gvp-clearence-report", { state:{data:response.data,formatDate: formInput.Date,shiftName:getShiftName(formInput.shiftId)}});
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsOptionsLoading(false);
    }
  };
  const handleTotalGvpTransactionClick = async (row) => {
    setIsOptionsLoading(true);
    try {
      const startTime = "00:00";
      const endTime = "23:59";
      // Concatenate start and end times with the date
      const startDate = `${formInput.Date}T${startTime}`;
      const endDate = `${formInput.Date}T${endTime}`;

      const response = await GetAllTotalClearedHotspotTransaction(
        startDate,
        endDate,
        formInput.shiftId,
        formInput.ownerTypeId,
        formInput.vehicleTypeId,
      );
      navigate("/view-Gvp-clearence-report", { state:{data:response.data,formatDate: formInput.Date,shiftName:getShiftName(formInput.shiftId)}});
    } catch (error) {
      console.log(error);
    } finally {
      setIsOptionsLoading(false);
    }
  };

  const handleGvpTransactionClick1 = async (row) => {
    setIsOptionsLoading(true);
    try {
      const startTime = "00:00";
      const endTime = "23:59";
      // Concatenate start and end times with the date
      const startDate = `${formInput1.Date}T${startTime}`;
      const endDate = `${formInput1.Date}T${endTime}`;

      // Call the API only when the "No of GVPs Cleared" field is clicked
      if (row.zoneId !== "" && row.circleId !== "") {
        // Call the API
        const response = await GetAllClearedHotspotTransaction(
          startDate,
          endDate,
          "",
          row.circleId,
          // formInput.ownerTypeId,
          formInput1.shiftId,
          formInput1.ownerTypeId,
          formInput1.vehicleTypeId,
        );
        // Handle the response here (e.g., navigate to a new page with the data)
        navigate("/view-Gvp-clearence-report", {state:{data:response.data,formatDate: formInput1.Date,shiftName:getShiftName(formInput1.shiftId)} });
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsOptionsLoading(false);
    }
  };

  const handleTotalGvpTransactionClick1 = async () => {
    setIsOptionsLoading(true);
    try {
      const startTime = "00:00";
      const endTime = "23:59";
      // Concatenate start and end times with the date
      const startDate = `${formInput.Date}T${startTime}`;
      const endDate = `${formInput.Date}T${endTime}`;

      const response = await GetAllClearedHotspotTransactionTotal(
        startDate,
        endDate,
        formInput1.shiftId,
        formInput1.ownerTypeId,
        formInput1.vehicleTypeId,
      );
      navigate("/view-Gvp-clearence-report", {state:{data:response.data,formatDate: formInput1.Date,shiftName:getShiftName(formInput1.shiftId)} });
    } catch (error) {
      console.log(error);
    } finally {
      setIsOptionsLoading(false);
    }
  };
  const handleCircleAllotedVehicleRCV = async (row) => {
    setIsOptionsLoading(true);
    try {
      const isActive = true;

      // const response = await GetAllVehicleDetailsByFilters(
      //   isActive,
      //   row.circleId
      // );
      if (row && row.circleId) {
        // Check if row and circleId are defined
        const response = await GetAllVehicleDetailsByFilters(
          isActive,
          formInput1.Date,
          row.circleId, // Pass circleId here
          formInput1.ownerTypeId,
          "2",
          formInput1.shiftId
        );

        navigate("/view-circle-inner-vehicle-alloted-rcv", {
          state: response.data,
        });
      } else {
        // Handle the case where row or circleId is undefined
        console.error("Row or circleId is undefined");
      }
      // Handle the response here (e.g., navigate to a new page with the data)
      // navigate("/view-circle-inner-vehicle-alloted-rcv", { state: response.data });
      // }
    } catch (error) {
      console.log(error);
    } finally {
      setIsOptionsLoading(false);
    }
  };

  const handleCircleNotReportedRCV = async (row) => {
    setIsOptionsLoading(true);
    try {
      const startTime = "00:00";
      const endTime = "23:59";
      let response;
      // Concatenate start and end times with the date
      const startDate = `${formInput1.Date}T${startTime}`;
      const endDate = `${formInput1.Date}T${endTime}`;
      if (row.zoneId !== "" && row.circleId === "") {
        response = await GetSecondaryVehicleNotReportedAtDeployment(
          formInput1.Date,
          formInput1.ownerTypeId,
          row.circleId,
          formInput1.shiftId
        );
      }
      if (row.zoneId !== "" && row.circleId !== "") {
        response = await GetSecondaryVehicleNotReportedAtDeployment(
          formInput1.Date,
          formInput1.ownerTypeId,
          row.circleId,
          formInput1.shiftId
        );
      }
      navigate("/scv-circle-not-reported-rcv", { state: response.data });
    } catch (error) {
      console.log(error);
    } finally {
      setIsOptionsLoading(false);
    }
  };

  const handleCirclereportedVehicleRCV = async (row) => {
    setIsOptionsLoading(true);
    try {
      const startTime = "00:00";
      const endTime = "23:59";
      let response;
      // Concatenate start and end times with the date
      const startDate = `${formInput1.Date}T${startTime}`;
      const endDate = `${formInput1.Date}T${endTime}`;
      if (row.zoneId !== "" && row.circleId === "") {
        response = await GetAllSecondaryDeploymentTransaction(
          startDate,
          endDate,
          "",
          row.circleId, // Pass empty string for circleId
          formInput1.ownerTypeId,
          formInput1.shiftId
        );
      }
      if (row.zoneId !== "" && row.circleId !== "") {
        response = await GetAllSecondaryDeploymentTransaction(
          startDate,
          endDate,
          "",
          row.circleId, // Pass empty string for circleId
          formInput1.ownerTypeId,
          formInput1.shiftId
        );
      }
      navigate("/scv-circle-reported-vehicle-rcv", { state: response.data });
    } catch (error) {
      console.log(error);
    } finally {
      setIsOptionsLoading(false);
    }
  };

  const handleCircleClearedCollectionPoint = async (row) => {
    setIsOptionsLoading(true);
    try {
      const startTime = "00:00";
      const endTime = "23:59";
      let response;
      // Concatenate start and end times with the date
      const startDate = `${formInput1.Date}T${startTime}`;
      const endDate = `${formInput1.Date}T${endTime}`;
      if (row.zoneId !== "" && row.circleId === "") {
        response = await GetAllClearedCollectionPointTransaction(
          startDate,
          endDate,
          "",
          row.circleId,
          formInput1.shiftId
        );
      }
      if (row.zoneId !== "" && row.circleId !== "") {
        response = await GetAllClearedCollectionPointTransaction(
          startDate,
          endDate,
          row.circleId,
          // row.circleId,
          formInput1.shiftId
        );
      }
      // navigate("/view-circle-inner-collection-point-trans", { state: response.data });
      navigate("/view-circle-inner-collection-point-trans", {
        state: Object.values(response.data),
      });
    } catch (error) {
      console.log(error);
    } finally {
      setIsOptionsLoading(false);
    }
  };

  const calculateZoneTotals = (data) => {
    const totals = {
      sno: "",
      zoneName: "Total",
      allotedVehicleRCV: 0,
      reportedVehicleRCV: 0,
      notReportedRCV: 0,
      clearedCollectionPoints: 0,
      numberOfHelpers: 0,
    };

    data.forEach((row) => {
      totals.allotedVehicleRCV += row.allotedVehicleRCV || 0;
      totals.reportedVehicleRCV += row.reportedVehicleRCV || 0;
      totals.notReportedRCV += row.notReportedRCV || 0;
      totals.clearedCollectionPoints += row.clearedCollectionPoints || 0;
      totals.numberOfHelpers += row.numberOfHelpers || 0;
    });
    return totals;
  };

  const calculateCircleTotals = (data) => {
    const totals = {
      sno: "Total",
      circleName: "Total",

      allotedVehicleRCV: 0,
      reportedVehicelRCV: 0,
      notReportedRCV: 0,
      clearedCollectionPoints: 0,
      numberOfHelpers: 0,
    };

    data.forEach((row) => {
      totals.allotedVehicleRCV += row.allotedVehicleRCV || 0;
      totals.reportedVehicelRCV += row.reportedVehicelRCV || 0;
      totals.notReportedRCV += row.notReportedRCV || 0;
      totals.clearedCollectionPoints += row.clearedCollectionPoints || 0;
      totals.numberOfHelpers += row.numberOfHelpers || 0;
    });
    return totals;
  };

  const totalZoneRow = calculateZoneTotals(circleZonewisereport);
  const zoneDataWithTotal = [...circleZonewisereport, totalZoneRow];

  const totalCircleRow = calculateCircleTotals(getCircleReport);
  const circleDataWithTotal = [...getCircleReport, totalCircleRow];

  return (
    <>
      <div style={{ width: "100%" }}>
        <div className="content">
          <div className="page-content">
            <h4 class="text-start mb-3">Reported SCVs at Circle</h4>
            <div className="row">
              <div className="col">
                <div className="">
                  <div className="row mb-5">
                    <div className="col-xl-12 col-md-12">
                      <div className="card">
                        <div className="card-body">
                          <Tabs
                            selectedIndex={selectedTab}
                            onSelect={handleTabSelect}
                          >
                            <TabList style={{ display: "flex" }}>
                              <Tab
                                className={`datatable_tabs ${isProd
                                    ? selectedTab === 0
                                      ? "active-ghmc"
                                      : "active-swm"
                                    : selectedTab === 0
                                      ? "active-default"
                                      : "inactive-default"
                                  }`}
                              >
                                Zone Wise Reported SCVs at Circle
                              </Tab>
                              <Tab
                                className={`datatable_tabs ${isProd
                                    ? selectedTab === 1
                                      ? "active-ghmc"
                                      : "active-swm"
                                    : selectedTab === 1
                                      ? "active-default"
                                      : "inactive-default"
                                  }`}
                              >
                                Circle Wise Reported SCVs at Circle
                              </Tab>
                            </TabList>

                            <TabPanel>
                              <div className="row align-items-center  mt-3">
                                <div className="col-md-10">
                                  <form
                                    onSubmit={handleSubmit(
                                      fetchCircleZonewisereport
                                    )}
                                  >
                                    <div
                                      className="row"
                                      style={{
                                        textAlign: "justify",
                                      }}
                                    >
                                      <div class="col-md-2">
                                        <label htmlFor="fromDate">Date:</label>
                                        <input
                                          type="date"
                                          name="date"
                                          value={formInput.Date}
                                          style={inputStyle}
                                          className="form-control"
                                          max={getCurrentDateTime()} // Set the max attribute to the current date
                                          onChange={(e) => {
                                            setFormInput({
                                              ...formInput,
                                              Date: e.target.value,
                                            });
                                            localStorage.setItem(
                                              "date",
                                              e.target.value
                                            );
                                          }}
                                        />
                                      </div>
                                      <div class="col-md-2">
                                        <label htmlFor="VehicleTypeId">Vehicle Type</label>
                                        <select
                                          className="form-select"
                                          style={{ backgroundColor: "#fff" }}
                                          name="vehicleTypeId"
                                          value={formInput.vehicleTypeId}
                                          id="vehicleTypeId"
                                          // onChange={(e) => setVehicleTypeId(e.target.value)}
                                          onChange={(e) => {
                                            setFormInput({
                                              ...formInput,
                                              vehicleTypeId: e.target.value,
                                            });
                                            localStorage.setItem(
                                              "vehicleType",
                                              e.target.value
                                            );
                                          }}
                                        >
                                          <option value="">All</option>
                                          {vehicleType
                                            .filter((vehicle) => vehicle.isActive)
                                            .map((vehicle) => (
                                              <option
                                                key={vehicle.vehicleTypeId}
                                                value={vehicle.vehicleTypeId}
                                              >
                                                {vehicle.vehicleTypeName}
                                              </option>
                                            ))}
                                        </select>
                                      </div>
                                      <div class="col-md-2">
                                        <label htmlFor="zone">Owner Type</label>
                                        <select
                                          className="form-select"
                                          style={inputStyle2}
                                          name="ownerTypeId"
                                          value={formInput.ownerTypeId}
                                          onChange={(e) => {
                                            setFormInput({
                                              ...formInput,
                                              ownerTypeId: e.target.value,
                                            });
                                            localStorage.setItem(
                                              "ownerType",
                                              e.target.value
                                            );
                                          }}
                                        >
                                          <option value="">
                                            All{" "}
                                          </option>
                                          {ownerType.filter((type)=>type.isActive).map((type) => (
                                            <option
                                              key={type.ownerTypeId}
                                              value={type.ownerTypeId}
                                            >
                                              {type.ownerTypeName}
                                            </option>
                                          ))}
                                        </select>
                                      </div>
                                      <div class="col-md-2">
                                        <label>Shift Type</label>
                                        <select
                                          className="form-select"
                                          style={inputStyle2}
                                          name="shiftId"
                                          value={formInput.shiftId}
                                          onChange={(e) => {
                                            setFormInput({
                                              ...formInput,
                                              shiftId: e.target.value,
                                            });
                                            localStorage.setItem(
                                              "shift",
                                              e.target.value
                                            );
                                          }}
                                        >
                                          {shiftType
                                            .filter((type) => type.isActive)
                                            .map((type) => (
                                              <option
                                                key={type.shiftId}
                                                value={type.shiftId}
                                              >
                                                {type.shiftName}
                                              </option>
                                            ))}
                                        </select>
                                      </div>
                                      <div class="col-md-3">
                                        <button
                                          type="submit"
                                          className={`btn mr-2 mt-4 ${isProd
                                              ? "search-ghmc"
                                              : "search-swm"
                                            }`}
                                        >
                                          Search
                                        </button>
                                        <button
                                          type="submit"
                                          onClick={() => {
                                            localStorage.removeItem("date");
                                            localStorage.removeItem("shift");
                                            localStorage.removeItem(
                                              "ownerType"
                                            );
                                            localStorage.removeItem(
                                              "vehicleType"
                                            );
                                            setFormInput({
                                              Date: getCurrentDateTime(),
                                              ownerTypeId: "",
                                              vehicleTypeId:"",
                                              shiftId: "1",
                                            });
                                          }}
                                          className={`btn mt-4 ${isProd
                                              ? "search-ghmc"
                                              : "search-swm"
                                            }`}
                                        >
                                          Reset
                                        </button>
                                      </div>
                                      <div className="col-md-3"></div>
                                    </div>
                                  </form>
                                </div>
                                <div className="col-md-12">
                                  <div className="text-end ">
                                    {/* <button
                                  //  onClick={() => generatePDF(searchResults)}
                                  style={{ marginBottom: "10px" }}
                                >
                                  Download Pdf
                                </button> */}
                                    <button
                                      className="btn btn-excel ms-auto mt-3"
                                      onClick={downloadAsExcel}
                                    >
                                      <i class="fa-solid fa-file-excel me-1 icon-container"></i>{" "}
                                      Excel
                                    </button>
                                  </div>
                                </div>
                              </div>

                              <div className="card mt-3">
                                <div className="">
                                  <div className="top-header">
                                    <span>
                                      {" "}
                                      Zone Wise Reported SCVs at Circle as on {formInput.Date?formattedDate(formInput.Date):getCurrentISTDate()} - {getShiftName(formInput.shiftId)} (at {getCurrentDateTime1()})
                                    </span>
                                  </div>
                                  <CustomDataTable
                                    data={zoneDataWithTotal}
                                    link={true}
                                    //  data={searchResults}
                                    columns={scvZoneReportColumns}
                                    isLoading={isLoading}
                                    // sortConfig={sortConfig}
                                    // handleSort={handleSort}
                                    footer={true}
                                  // footerCount={true}
                                  />
                                </div>
                              </div>
                            </TabPanel>
                            <TabPanel>
                              <div className="row justify-content-between align-items-center  mt-3">
                                <div className="col-md-10">
                                  <form
                                    onSubmit={searchCircleReport}
                                    class="row "
                                    style={{ textAlign: "justify" }}
                                  >
                                    <div class="col-md-2">
                                      <label htmlFor="fromDate">Date:</label>
                                      <input
                                        type="date"
                                        id="fromDate"
                                        value={formInput1.Date}
                                        max={getCurrentDateTime()} // Set the max attribute to the current date
                                        style={inputStyle}
                                        className="form-control"
                                        // value={`${fromDate}T${fromTime}`}
                                        onChange={(e) => {
                                          setFormInput1({
                                            ...formInput1,
                                            Date: e.target.value,
                                          });
                                          localStorage.setItem(
                                            "Circledate",
                                            e.target.value
                                          );
                                        }}
                                      />
                                    </div>
                                    <div class="col-md-2">
                                        <label htmlFor="VehicleTypeId">Vehicle Type</label>
                                        <select
                                          className="form-select"
                                          style={{ backgroundColor: "#fff" }}
                                          name="vehicleTypeId"
                                          value={formInput1.vehicleTypeId}
                                          id="vehicleTypeId"
                                          // onChange={(e) => setVehicleTypeId(e.target.value)}
                                          onChange={(e) => {
                                            setFormInput1({
                                              ...formInput1,
                                              vehicleTypeId: e.target.value,
                                            });
                                            localStorage.setItem(
                                              "CircleVehicleType",
                                              e.target.value
                                            );
                                          }}
                                        >
                                          <option value="">All</option>
                                          {vehicleType
                                            .filter((vehicle) => vehicle.isActive)
                                            .map((vehicle) => (
                                              <option
                                                key={vehicle.vehicleTypeId}
                                                value={vehicle.vehicleTypeId}
                                              >
                                                {vehicle.vehicleTypeName}
                                              </option>
                                            ))}
                                        </select>
                                      </div>
                                    <div class="col-md-2">
                                      <label htmlFor="zone">Owner Type</label>
                                      <select
                                        className="form-select"
                                        style={inputStyle2}
                                        name="ownerTypeId"
                                        id="ownerTypeId"
                                        value={formInput1.ownerTypeId}
                                        onChange={(e) => {
                                          setFormInput1({
                                            ...formInput1,
                                            ownerTypeId: e.target.value,
                                          });
                                          localStorage.setItem(
                                            "CircleOwnerType",
                                            e.target.value
                                          );
                                        }}
                                      >
                                        <option value="">All</option>
                                        {ownerType.filter((type)=>type.isActive).map((type) => (
                                          <option
                                            key={type.ownerTypeId}
                                            value={type.ownerTypeId}
                                          >
                                            {type.ownerTypeName}
                                          </option>
                                        ))}
                                      </select>
                                    </div>
                                    <div class="col-md-2">
                                      <label htmlFor="zone">Shift Type</label>
                                      <select
                                        className="form-select"
                                        style={inputStyle2}
                                        name="shiftId"
                                        value={formInput1.shiftId}
                                        onChange={(e) => {
                                          setFormInput1({
                                            ...formInput1,
                                            shiftId: e.target.value,
                                          });
                                          localStorage.setItem(
                                            "CircleShift",
                                            e.target.value
                                          );
                                        }}
                                      >
                                        {shiftType
                                          .filter((type) => type.isActive)
                                          .map((type) => (
                                            <option
                                              key={type.shiftId}
                                              value={type.shiftId}
                                            >
                                              {type.shiftName}
                                            </option>
                                          ))}
                                      </select>
                                    </div>
                                    <div className="col-md-4">
                                      <button
                                        type="submit"
                                        // onClick={searchCircleReport}
                                        className={`btn mt-4 mr-2 ${isProd ? "search-ghmc" : "search-swm"
                                          }`}
                                      >
                                        Search
                                      </button>
                                      <button
                                        type="submit"
                                        onClick={() => {
                                          localStorage.removeItem("Circledate");
                                          localStorage.removeItem(
                                            "CircleShift"
                                          );
                                          localStorage.removeItem(
                                            "CircleOwnerType"
                                          );
                                          localStorage.removeItem(
                                            "CircleVehicleType"
                                          );
                                          setFormInput1({
                                            Date: getCurrentDateTime(),
                                            ownerTypeId: "",
                                            vehicleTypeId:"",
                                            shiftId: 1,
                                          });
                                        }}
                                        className={`btn mt-4 ${isProd ? "search-ghmc" : "search-swm"
                                          }`}
                                      >
                                        Reset
                                      </button>
                                    </div>
                                    <div className="col-md-3"></div>
                                  </form>
                                </div>
                                <div className="col-md-12">
                                  <div className="text-end  mt-3">
                                    <button
                                      className="btn btn-excel ms-auto mt-4"
                                      onClick={
                                        downloadAsExcelforCircleWiseReport
                                      }
                                    >
                                      <i class="fa-solid fa-file-excel me-1 icon-container"></i>{" "}
                                      Excel
                                    </button>
                                  </div>
                                </div>
                              </div>

                              <div className="card mt-3">
                                <div className="top-header">
                                  <span>
                                    {" "}
                                    Circle Wise Reported SCVs at Circle {formInput1.Date?formattedDate(formInput1.Date):getCurrentISTDate()} - {getShiftName(formInput1.shiftId)} (at {getCurrentDateTime1()})
                                  </span>
                                </div>
                                <CustomDataTable
                                  data={circleDataWithTotal}
                                  columns={scvCircleReportColumns}
                                  footer={true}
                                />
                              </div>
                            </TabPanel>
                          </Tabs>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {isLoading && <Loader />}
    </>
  );
};

export default CircleReport;

// Function to get current date and time in the required format
const getCurrentDateTime = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  // const hour = String(now.getHours()).padStart(2, "0");
  // const minute = String(now.getMinutes()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const inputStyle = {
  backgroundColor: "#fff",
  height: "38px",
  border: "1px solid #E2E2E2",
  padding: "15px",
  borderRadius: "0px",
};

const inputStyle2 = {
  backgroundColor: "#fff",
  height: "38px",
  border: "1px solid #E2E2E2",
  // padding: "15px",
  borderRadius: "0px",
};
